import { Stack } from 'libs/ui';

import { FormContent, FormContentProps } from './FormContent';

interface Props extends FormContentProps {}

export const AdditionalDocumentsSection = ({ ...formProps }: Props) => (
  <Stack datax="additionalDocumentsSection" spacing={32}>
    <FormContent {...formProps} />
  </Stack>
);
